import { PerformerItemView } from '../model/performer-item-view.model';

export function applyMovementOfRanking(item: PerformerItemView): void {
    item.movementOfRankingAbs = Math.abs(item.movementOfRanking);
    item.movementOfRankingClass = 'cmps-mi2-main--movement--neutral';
    item.movementOfRankingIcon = 'minus';
    if (item.movementOfRanking < 0) {
        item.movementOfRankingClass = 'cmps-mi2-main--movement--down';
        item.movementOfRankingIcon = 'menu-down';
    } else if (item.movementOfRanking > 0) {
        item.movementOfRankingClass = 'cmps-mi2-main--movement--up';
        item.movementOfRankingIcon = 'menu-up';
    }
}
